<template>
  <div>
    <slot :onToggle="onToggle" :open="open"></slot>
  </div>
</template>

<script>
import { EventBus } from "../../EventBus";

export default {
  name: "VHeader",
  data() {
    return {
      current: null,
      open: false,
    };
  },
  provide() {
    return {
      onOpen: this.onCurrent,
      open: () => {
        return this.current;
      },
    };
  },
  methods: {
    onCurrent(i) {
      this.current = i == this.current ? null : i;
    },
    onToggle() {
      this.open = !this.open;
      this.current = null;
    },
  },
  mounted() {
    if (!document._megamenuFocusInListener) {
      const handler = (event) => {
        EventBus.$emit("focus-outside", { target: event.target });
      };

      document.addEventListener("focusin", handler);
      document.addEventListener("click", handler);
      document.addEventListener("touchstart", handler, { passive: true });

      document._megamenuFocusInListener = true;
      document._megamenuFocusInHandler = handler;
    }
  },
  beforeUnmount() {
    if (document._megamenuFocusInListener && document._megamenuFocusInHandler) {
      document.removeEventListener("focusin", document._megamenuFocusInHandler);
      document.removeEventListener("click", document._megamenuFocusInHandler);
      document.removeEventListener(
        "touchstart",
        document._megamenuFocusInHandler
      );

      delete document._megamenuFocusInListener;
      delete document._megamenuFocusInHandler;
    }
  },
};
</script>
